import { UntypedFormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomValidators {
  minyear(control: UntypedFormGroup): { [key: string]: any } {
    const newStr = control.value.split('.');
    if (+newStr[2] < 1917) {
      return { minyear: true };
    } else {
      return null;
    }
  }

  phonelength(control: UntypedFormGroup): { [key: string]: any } {
    if (control.value === '') {
      return null;
    }
    const value = control.value.replace(/[+()\-_ ]+/g, '');
    return value.length === 10 ? null : { phonelength: true };
  }

  nonexistentphone(control: UntypedFormGroup): { [key: string]: any } {
    if (control.value === '') {
      return null;
    }
    const value = control.value.replace(/[+()\-_ ]+/g, '');
    return value.charAt(0) === '9' ? null : { nonexistentphone: true };
  }

  coincidenceofphones(control: UntypedFormGroup): { [key: string]: any } {
    const group = control.parent.parent.controls['mainPhone'].value;
    if (control.value === group) {
      return { coincidenceofphones: true };
    } else {
      return null;
    }
  }

  requiredtrue(control: UntypedFormGroup): { [key: string]: any } {
    return control.value ? null : { requiredtrue: true };
  }

  nonexistentpassport(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value;
    return value[0] + value[1] === '00'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '02'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '06'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '13'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '16'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '21'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '23'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '31'
      ? { nonexistentpassport: true }
      : value[0] + value[1] === '35'
      ? { nonexistentpassport: true }
      : null;
  }

  lengthpassport(control: UntypedFormGroup): { [key: string]: any } {
    const serial = parseInt(control.value.split(' ')[0]) + '';
    const number = parseInt(control.value.split(' ')[1]) + '';
    if (serial.length < 4 || number.length < 6) {
      return { lengthpassport: true };
    } else {
      return null;
    }
  }

  forbiddenseries(control: UntypedFormGroup): { [key: string]: any } {
    const forbidden = ['00', '02', '06', '13', '16', '21', '23', '31', '35'];
    const series = control.value.replace(/\D/g, '');
    let format;
    let result = true;
    if (series.length === 4) {
      format = series.substr(0, 2);
      forbidden.forEach((e) => {
        if (e === format) {
          result = false;
        }
      });
    }
    return result ? null : { forbiddenseries: true };
  }

  lengthpassportseries(control: UntypedFormGroup): { [key: string]: any } {
    const series = control.value.replace(/\D/g, '');
    return series.length < 4 && series.length > 0
      ? { lengthpassportseries: true }
      : null;
  }

  lengthpassportnumber(control: UntypedFormGroup): { [key: string]: any } {
    const number = control.value.replace(/\D/g, '');
    return number.length < 6 && number.length > 0
      ? { lengthpassportnumber: true }
      : null;
  }

  lengthsubdivision(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.replace(/_/g, '').length < 7
      ? { lengthsubdivision: true }
      : null;
  }

  lengthsnils(control: UntypedFormGroup): { [key: string]: any } {
    const len = control.value.replace(/[\s\-]/gi, '').length;
    return len < 11 && len !== 0 ? { lengthsnils: true } : null;
  }

  calccontrolsummsnils(control: UntypedFormGroup): { [key: string]: any } {
    const valueClean = control.value.replace(/-/g, '');
    let valueFinal = valueClean.replace(' ', '');
    const checkSum = parseInt(valueFinal.slice(9), 10);
    valueFinal = '' + valueFinal;
    valueFinal = valueFinal.split('');

    const sum =
      valueFinal[0] * 9 +
      valueFinal[1] * 8 +
      valueFinal[2] * 7 +
      valueFinal[3] * 6 +
      valueFinal[4] * 5 +
      valueFinal[5] * 4 +
      valueFinal[6] * 3 +
      valueFinal[7] * 2 +
      valueFinal[8] * 1;

    if (sum < 100) {
      return sum === checkSum ? null : { calccontrolsummsnils: true };
    }

    if (sum === 100 || sum === 101) {
      return checkSum === 0 ? null : { calccontrolsummsnils: true };
    }

    if (sum > 101) {
      return sum % 101 === checkSum || (sum % 101 === 100 && checkSum === 0)
        ? null
        : { calccontrolsummsnils: true };
    }
  }

  notfulldate(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.replace(/[+()\-_ .]+/g, '').length < 8 &&
      control.value.replace(/[+()\-_ .]+/g, '').length > 0
      ? { notfulldate: true }
      : null;
  }

  notfuturedate(control: UntypedFormGroup): { [key: string]: any } {
    const controlRes = control.value.split('.');
    const date: any = new Date(
      controlRes[2] + '-' + controlRes[1] + '-' + controlRes[0]
    );
    const today: any = new Date();
    return date.getTime() > today.getTime() ? { notfuturedate: true } : null;
  }

  notexisteddate(control: UntypedFormGroup): { [key: string]: any } {
    let date, day, month, dateMonth, year, res;
    if (control.value.replace(/[+()\-_ .]+/g, '').length > 7) {
      if (control.value.includes('-')) {
        date = new Date(control.value);
        day =
          date.getDate().toString().length === 1
            ? '0' + date.getDate()
            : date.getDate();
        dateMonth = date.getMonth() + 1;
        month = dateMonth.toString().length === 1 ? '0' + dateMonth : dateMonth;
        year = date.getFullYear();
        res = year + '-' + month + '-' + day;
      } else {
        const controlRes = control.value.split('.');
        date = new Date(
          controlRes[2] + '-' + controlRes[1] + '-' + controlRes[0]
        );
        dateMonth = date.getMonth() + 1;
        day =
          date.getDate().toString().length === 1
            ? '0' + date.getDate()
            : date.getDate();
        month = dateMonth.toString().length === 1 ? '0' + dateMonth : dateMonth;
        year = date.getFullYear();
        res = day + '.' + month + '.' + year;
      }
    }
    return control.value === res ? null : { notexisteddate: true };
  }

  complicacy(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.length <= 5 ? { lengthpassword: true } : null;
  }

  empty(control: UntypedFormGroup): { [key: string]: any } {
    if (control.value.length === 0) {
      return { empty: true };
    } else {
      return null;
    }
  }
}
